/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\DropZone.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 24th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 24th 2023 4:48:46 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const DropZone = styled.div.attrs(props => {return ({
    bgColor: props.bgColor,
})})`
position: relative;
border: dashed 3px var(--theme-color);
border-radius: 10px;
color: var(--theme-bg-color);
height: 8rem;
width: 10rem;
margin: auto;
padding: 1rem;
text-align: center;
overflow: hidden;

[type="file"] {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
`;

export default DropZone;
